import { BookingUnableToCompleteFilter } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { UNABLE_TO_COMPLETE_STATUS_OPTIONS } from 'noddi-util';

/** Partially and fully unable to complete. */
export const UNABLE_TO_COMPLETE_STATUS_FILTER_OPTIONS: FilterOption<BookingUnableToCompleteFilter>[] =
  UNABLE_TO_COMPLETE_STATUS_OPTIONS.map((status) => ({ label: status.label, value: status.value }));
